export interface CompanyMember{
  account_id: number
  cor_id: string
  created_at: string
  deleted_at: null | string
  disabled_at: null | string
  first_name: string
  id: number
  last_name: string
  limit_amount: string
  isDisabled: boolean,
  limit_period: CompanyMemberLimitPeriod
  updated_at: null | string
}

export enum CompanyMemberLimitPeriod{
  day= "day",
  week = "week",
  month = "month",
  year = "year",
}

